export enum EnumTipoColumna {
  Operacion = 1,
  Agregado = 2
}
